<template>
  <h2 style="text-align: center;">Colors</h2>
  <MDBTabs v-model="controlName">
    <MDBTabNav tabsClasses="mb-3">
      <MDBTabItem tabId="DSTColors" href="DSTColors">DST Colors</MDBTabItem>
      <MDBTabItem tabId="SVGColors" href="SVGColors">SVG Colors</MDBTabItem>
    </MDBTabNav>
    
    <MDBTabContent>
      <MDBTabPane tabId="DSTColors">
  <form class="card col-md-6 offset-md-3">
    <div class="row p-2">
      <div class="col-md-2">
        <label class="form-text"> Color {{ color }}</label>
        <input class="form-control" type="color" v-model="color" />
      </div>
      <div class="col-md-4">
        <label class="form-text"> Name </label>
        <input class="form-control" type="text" v-model="name" />
      </div>
      <div class="col-md-4">
        <label class="form-text"> Thread # </label>
        <input class="form-control" type="text" v-model="threadCode" />
      </div>
      <div class="col-md-2 p-3" title="Add color">
        <icon-svg
          icon="material-symbols:add-circle-outline"
          :height="35"
          :width="35"
          style="cursor: pointer"
          @click="addColor()"
        />
      </div>
    </div>
  </form>
  <div class="row mt-2">
    <div class="col-md-8">
      <table class="table responsive-table">
        <thead>
          <tr>
            <td>Color name</td>
            <td>Thread #</td>
            <td>Color code</td>
            <td>Remove</td>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(col, index) in store.getAllColors()" :key="index">
            <td>{{ col.colorName }}</td>
            <td>{{ col.threadCode }}</td>
            <td>
              <span
                class="badge oultine-text"
                :style="{ backgroundColor: col.color }"
              >
                {{ col.color }}
              </span>
            </td>
            <td>
              <icon-svg
                icon="ic:baseline-delete"
                :height="25"
                :width="25"
                style="cursor: pointer"
                @click="removeColor(col.colorID)"
                
              />
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</MDBTabPane>
<MDBTabPane tabId="SVGColors">
  <form class="card col-md-6 offset-md-3">
    <div class="row p-2">
      <div class="col-md-2">
        <label class="form-text"> Color {{ color }}</label>
        <input class="form-control" type="color" v-model="color" />
      </div>
      <div class="col-md-4">
        <label class="form-text"> Name </label>
        <input class="form-control" type="text" v-model="name" />
      </div>
      <div class="col-md-4">
        <label class="form-text"> Thread # </label>
        <input class="form-control" type="text" v-model="threadCode" />
      </div>
      <div class="col-md-2 p-3" title="Add color">


        
        <icon-svg
        
          icon="material-symbols:add-circle-outline"
          :height="35"
          :width="35"
          style="cursor: pointer"
          @click="addColorSVG()"
               
        />
      </div>
    </div>
  </form>
  <div class="row mt-2">
    <div class="col-md-8">
      <table class="table responsive-table">
        <thead>
          <tr>
            <td>Color name</td>
            <td>Thread #</td>
            <td>Color code</td>
            <td>Remove</td>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(col, index) in store.getAllSVGColors()" :key="index">
            <td>{{ col.colorName }}</td>
            <td>{{ col.threadCode }}</td>
            <td>
              <span
                class="badge oultine-text"
                :style="{ backgroundColor: col.color }"
              >
                {{ col.color }}
              </span>
            </td>
            <td>
              <icon-svg
                icon="ic:baseline-delete"
                :height="25"
                :width="25"
                style="cursor: pointer"
                @click="removeColorSVG(col.colorID)"


              />
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</MDBTabPane>
    </MDBTabContent>
  </MDBTabs>
  <!-- <div class="columns">
    <template>
      <div class="column is-2"></div>

      <span>&nbsp;</span>
    </template>
  </div> -->
</template>


<script>
import { designerStore } from "@/stores/designerStore";
import {
  MDBTabs,
  MDBTabNav,
  MDBTabContent,
  MDBTabItem,
  MDBTabPane,
} from "mdb-vue-ui-kit";
import { ref } from "vue";


export default {
  setup() {
    const store = designerStore();
    const controlName = ref("DSTColors");

    return {
      store,
      controlName
    };
  },
  components: {    
    MDBTabs,
    MDBTabNav,
    MDBTabContent,
    MDBTabItem,
    MDBTabPane,
  },
  data() {
    return {
      color: "#ffffff",
      name: "",
      threadCode: "",
    };
  },
  methods: {
    addColor() {
      console.log(" color name = " + this.name);
      this.store.addColor(this.name, this.color, this.threadCode);
      this.color = "#ffffff";
      this.name = "";
      this.threadCode = "";
    },    
    addColorSVG() {
      console.log(" color name = " + this.name);
      this.store.addColorSVG(this.name, this.color, this.threadCode);
      this.color = "#ffffff";
      this.name = "";
      this.threadCode = "";
    },
    removeColorSVG(colorID) {
      this.store.removeColorSVG(colorID);
    },
    removeColor(colorID) {
      this.store.removeColor(colorID);
    },
  },
};
</script>
 <style >

.oultine-text {
  -webkit-text-stroke: 0.5px black;
  border: 1px black solid;
  width: 100px;
}
</style>

